import * as React from 'react';
import injectSheet from 'react-jss';
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Radio from 'antd/lib/radio';
import Icon from 'antd/lib/icon';
import Modal from 'antd/lib/modal';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import moment from 'moment';
import { withRouter } from 'react-router';
import ExcelUpload from 'src/components/common/ExcelUpload';
import { MIN_WIDTH } from 'src/globals';
import {
  inquiryModes,
  defaultAccessKeys,
  visibleAccessTypeLabel,
  InquiryModes,
  teamMappedAccessKeys,
  visibleAccessTypeLabelsForTeamMapped,
} from 'src/components/pages/Enquiry/InquiryUtils';
import { downloadFileData, arrayToObject } from 'src/utils/utils';
import { downloadSampleInquiry, bulkInquiryCreation } from 'src/api/inquiry';
import { fetchLinkedFFs, fetchOrganisationFFGroups } from 'src/api/masters';
import FailureArrayHandlerInquiry from 'src/components/common/FailureArrayHandlerInquiry';
import { connect } from 'react-redux';
import { fetchAllTeams, fetchUserTeams } from 'src/api/teams';
import TeamForInquiryAccessModal from './TeamForInquiryAccessModal';
import { clone, trimString, isValidArray } from 'src/Library/Helper';
import { fetchStrategicVendorList } from 'src/Library/Common';
import { FFType } from '../../DiscoverRate/DiscoverRateUtils';
import { KeyLabel } from 'src/Library/Types';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  footerDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  inquiryAccessDiv: {
    marginLeft: '10px',
    fontSize: `${tokens.fontSize.small}px`,
    textAlign: 'left',
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    '& .ant-select-selection--single': {
      fontSize: `${tokens.fontSize.small}px`,
    },
  },
  accessField: {
    width: '100%',
    '& .ant-select': {
      minWidth: '25%',
      width: 'auto',
    },
  },
});
class BulkInquiryUpload extends React.Component<any, any> {
  state = {
    inquiryMode: inquiryModes[0].value,
    fetchingFFs: false,
    fetchedFFs: [],
    selectedFFs: [],
    selectAll: false,
    parsedData: null,
    parsedDataSheet2: null,
    isUploading: false,
    tempUploadFlag: false,
    isErrorModalVisible: false,
    failureData: [],
    mapFetchedFFs: {},
    teams: [],
    accessType: undefined,
    isSelectTeamModalVisible: false,
    teamName: undefined,
    teamId: undefined,
    strategicFFs: [],
    selectedStrategicFFs: [],
    selectAllStrategicFFs: false,
  };

  componentDidMount() {
    const {isDefaultInquiryTeamMapping, userData } = this.props
    const showDefaultMappedUserTeam = isDefaultInquiryTeamMapping && userData.role !== 'ADMIN'
    this.fetchFFs();
    this.fetchTeams(showDefaultMappedUserTeam);
  }

  fetchTeams = async (showDefaultMappedUserTeam: boolean) => {
    const organisationId = this.props.userData.organisation_id;

    if (showDefaultMappedUserTeam){
      /**
       * Fetch user teams and set default team here
       */
      const response = await fetchUserTeams()

      if (response.isSuccess) {
        const filteredTeams  = response.data.filter(team => team.organisation_id === organisationId);
        response.data && response.data.length
          ? this.setState({
            teams: filteredTeams,
            accessType: filteredTeams && filteredTeams.length > 0 ? 'TEAM' : undefined,
            teamId: filteredTeams ? filteredTeams[0].id : undefined,
            teamName:
              filteredTeams ? `${filteredTeams[0].name} (${filteredTeams[0].reference_number})`: undefined,
          })
          : this.setState({ accessType: 'PRIVATE' });
      } else {
        message.error(response.errorMessage);
      }
    } else {
      /**
       * Fetch all teams and set it here 
       */
      const response = await fetchAllTeams({ adminTeamRestriction: false, getAllTeams: false });
      if (response.isSuccess) {
        const filteredTeams  = response.data.filter(team => team.organisation_id === organisationId);

        response.data && response.data.length
          ? this.setState({
            teams: filteredTeams,
            accessType: filteredTeams && filteredTeams.length > 1 ? 'TEAM' : undefined,
            teamId: filteredTeams && filteredTeams.length === 1 ? filteredTeams[0].id : undefined,
            teamName:
              filteredTeams && filteredTeams.length === 1 ? `${filteredTeams[0].name} (${filteredTeams[0].reference_number})` : undefined,
          })
          : this.setState({ accessType: 'PUBLIC' });
      } else {
        message.error(response.errorMessage);
      }
    }
  };

  fetchFFs = async () => {
    const { showDiscoverBuyRates, hideStrategicVendors } = this.props;
    const { inquiryMode } = this.state;
    this.setState({
      fetchingFFs: true,
    });
    const responses = await Promise.all([
      fetchLinkedFFs({
        organisationType: 'FF',
        mode: inquiryMode,
      }),
      fetchOrganisationFFGroups({}),
    ]);
    let fetchedFFs: any[] = [];
    responses.forEach((response: any, index) => {
      if (!response.isSuccess) {
        message.error(response.errorMessage);
      }
      const formatResponse = response.data
        ? response.data.map((item) => {
            return {
              key: item.id,
              label: item.name,
              isGroup: index !== 0,
            };
          })
        : [];
      fetchedFFs = [...fetchedFFs, ...formatResponse];
    });
    const ffList = fetchedFFs?.map((item) => item.key) || [];
    const strategicFFs = showDiscoverBuyRates && !hideStrategicVendors
      ? await fetchStrategicVendorList(ffList, [], inquiryMode)
      : [];
    this.setState({
      strategicFFs,
      fetchedFFs,
      fetchingFFs: false,
      mapFetchedFFs: arrayToObject(fetchedFFs, 'key'),
    });
  };

  handleModalClose = (isSuccess) => {
    this.props.onModalClose(isSuccess);
  };

  handleDownloadSampleData = async () => {
    const { inquiryMode } = this.state;
    const response = await downloadSampleInquiry({
      inquiryMode,
    });
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    } else {
      downloadFileData(
        response.data,
        response.filename || `sample-inquiry-${moment().format('DD-MM-YYYY')}.xlsx`,
        true
      );
      message.success('Downloaded successfully');
    }
  };

  handleRadioChange = (event) => {
    this.setState(
      {
        inquiryMode: event.target.value,
        parsedData: null,
        parsedDataSheet2: null,
        selectedFFs: [],
      },
      () => this.fetchFFs()
    );
  };

  getValueFromKeyMap = (type: string, option: string) => {
    const {
      selectedStrategicFFs,
      strategicFFs,
      fetchedFFs,
      selectAll,
      selectedFFs,
      selectAllStrategicFFs,
    } = this.state;
    let keyMap;
    if (type === FFType.STRATEGIC_FF) {
      keyMap = {
        selectedFFList: selectedStrategicFFs,
        selectedFFListKey: 'selectedStrategicFFs',
        ffList: strategicFFs,
        selectAllKey: 'selectAllStrategicFFs',
        isSelectAll: selectAllStrategicFFs,
      };
    } else {
      keyMap = {
        selectedFFList: selectedFFs,
        selectedFFListKey: 'selectedFFs',
        ffList: fetchedFFs,
        selectAllKey: 'selectAll',
        isSelectAll: selectAll,
      };
    }
    return keyMap[option];
  };

  handleChange = (options, selectAll, type) => {
    const ffList = this.getValueFromKeyMap(type, 'ffList');
    const selectedFFs = this.getValueFromKeyMap(type, 'selectedFFListKey');
    const selectAllKey = this.getValueFromKeyMap(type, 'selectAllKey');
    const isAllinoptions = options.find((opt) => opt.key === 'all');
    if (isAllinoptions) {
      this.setState({
        [selectAllKey]: !selectAll,
        [selectedFFs]: !selectAll ? clone(ffList) : [],
      });
    } else {
      this.setState({
        [selectedFFs]: options.map((opt) => {
          return {
            key: opt.key,
            label: opt.props.children,
          };
        }),
        [selectAllKey]: false,
      });
    }
  };

  getCorrectedDate(date: Date): Date{
    // values in seconds

    // https://github.com/SheetJS/sheetjs/issues/1212#issuecomment-413859298
    // https://github.com/SheetJS/sheetjs/issues/1212#issuecomment-534707231
    const mins = ((new Date('Dec 31, 1900 00:00:00')).getTime() - (new Date('Dec 31, 1900 00:00:00 GMT+00:00')).getTime())/60000;
    const TimeCorrect = Number((60 * (mins - Number(mins.toFixed(0)))).toFixed(0));
    const floatingPointErrorSafetyBuffer = 1; 
    const bugCorrectionForClient = (-1)*TimeCorrect  + floatingPointErrorSafetyBuffer;
    // const bugCorrectionForIndia = (-1)*(-10) + 1; 

    const convertClientTimeToUTC = new Date().getTimezoneOffset()*(60);

    const convertUTCToIndianTime = 19800;
    const addIndianTimeToFoolServer = 19800;
    
    /*
     * this will forcefully advance the time by indian time(+05:30) because
     * backend is expecting time in Asia/Kolkata, 
     * even though we specify as z i.e. UTC when sending in network request from frontend
     * backend thinks that the time given in z format is Asia/Kolkata
     */
    date.setSeconds(
      date.getSeconds() 
      + bugCorrectionForClient 
      + convertClientTimeToUTC 
      + convertUTCToIndianTime 
      + addIndianTimeToFoolServer
      );
    return date;
  }

  handleParsedData = (data, sheet2 = false) => {
    if (data) {
      const newParsedData = data
        .filter((item) => {
          for (const key in item) {
            if (item[key]) {
              return true;
            }
          }
          return false;
        })
        .map((item) => {
          for (const key in item) {
            if (trimString(item[key]) === '') {
              delete item[key];
            } else if (Object.prototype.toString.call(item[key]) === "[object Date]"){
              item[key] = this.getCorrectedDate(item[key]);
            }
          }
          return item;
        });
      if (sheet2) {
        this.setState({
          parsedDataSheet2: newParsedData,
        });
      } else {
        this.setState({
          parsedData: newParsedData,
        });
      }
    } else {
      if (sheet2) {
        this.setState({
          parsedDataSheet2: [],
        });
      } else {
        this.setState({
          parsedData: [],
        });
      }
    }
  };

  getCheckedFFs = (isGroup) => {
    const { selectedFFs, mapFetchedFFs }: any = this.state;
    return selectedFFs
      .filter((ff: any) => {
        return mapFetchedFFs[ff.key].isGroup === isGroup;
      })
      .map((ff: any) => {
        return ff.key;
      });
  };

  keyMapping = (sheet2 = false) => {
    const { inquiryMode } = this.state;
    const {
      masterData: { inquiryBulkUploadKeyMapping, inquiryBulkUploadKeyMappingSheet2 },
    } = this.props;
    if (sheet2) {
      return inquiryBulkUploadKeyMappingSheet2[inquiryMode];
    }
    return inquiryBulkUploadKeyMapping[inquiryMode];
  };

  handleTeamSelect = (team) => {
    this.setState({
      accessType: 'TEAM',
      teamId: team.id,
      teamName: team.name,
      isSelectTeamModalVisible: false,
    });
  };

  sendData = async () => {
    const parsedData: any = this.state.parsedData;
    const parsedDataSheet2: any = this.state.parsedDataSheet2;
    const { accessType, teamId, selectedStrategicFFs } = this.state;
    const ffIds = this.getCheckedFFs(false);
    const ffGroupIds = this.getCheckedFFs(true);
    const strategicFFs = selectedStrategicFFs?.map((ff: KeyLabel) => ff.key);
    if (!parsedData) {
      message.error('Please upload the file and try again.');
      return;
    }
    if (!accessType) {
      message.error('Please Select Inquiry Access');
      return;
    }
    this.setState({ isUploading: true });
    const body = {
      strategicFFs,
      data: parsedData,
      sheet2: parsedDataSheet2,
      ...(ffIds.length && {
        ffIds,
      }),
      ...(ffGroupIds.length && {
        ffGroupIds,
      }),
      accessType,
      teamId,
    };
    const response = await bulkInquiryCreation(body, this.state.inquiryMode);
    if (response.isSuccess) {
      this.setState({ isUploading: false });
      if (response.data && response.data.failureArray && response.data.failureArray.length > 0) {
        this.setState({
          isErrorModalVisible: true,
          failureData: response.data,
        });
      } else {
        this.handleModalClose(true);
        message.success(response?.data?.successMessage);
      }
    } else {
      this.setState({ isUploading: false });
      message.error(response.errorMessage);
    }
  };

  handleAccessTypeChange = async (val) => {
    if (val !== 'TEAM') {
      this.setState({ accessType: val, teamId: undefined });
      return;
    }
    this.setState({ isSelectTeamModalVisible: true });
  };

  getSelectedValues = (type) => {
    const selectedFFList = this.getValueFromKeyMap(type, 'selectedFFList');
    return selectedFFList?.map((ff: any) => ff.key) || undefined;
  };

  renderSelectFFs = (type) => {
    const { classes, permissions } = this.props;
    const { INQUIRY_SEND_ACTIONS } = permissions;
    const { fetchingFFs } = this.state;
    const ffList = this.getValueFromKeyMap(type, 'ffList');
    const selectAllKey = this.getValueFromKeyMap(type, 'isSelectAll');
    return (
      <Select
        allowClear
        showSearch
        mode="multiple"
        disabled={fetchingFFs || !INQUIRY_SEND_ACTIONS}
        className={classes.multiselect}
        placeholder="Select Vendors"
        value={this.getSelectedValues(type)}
        style={{ width: '100%' }}
        showArrow={true}
        optionFilterProp="children"
        onChange={(filtervals, options) => {
          this.handleChange(options, selectAllKey, type);
        }}
      >
        <Select.Option key={'all'}>Select All</Select.Option>
        {ffList.map((item: any) => {
          return <Select.Option key={item.key}>{item.label}</Select.Option>;
        })}
      </Select>
    );
  };

  render() {
    const { isVisible, classes, showDiscoverBuyRates, hideStrategicVendors, visibleAccessTypes, isDefaultInquiryTeamMapping, userData } = this.props;
    const {
      inquiryMode,
      fetchingFFs,
      isErrorModalVisible,
      failureData,
      fetchedFFs,
      selectedFFs,
      selectAll,
      isUploading,
      tempUploadFlag,
      teams,
      isSelectTeamModalVisible,
      teamName,
      teamId,
      accessType,
      strategicFFs,
    } = this.state;
    const accessIcons = {
      PUBLIC: <Icon type="global" />,
      PRIVATE: <Icon type="user" />,
      TEAM: <Icon type="team" />,
    };
    // const accessIcons = [<Icon type="global" />, <Icon type="user" />, <Icon type="team" />];
    const teamLabel = (
      <>
        <Icon type="team"></Icon> {this.state.teamName}
      </>
    );

    return (
      <Modal
        title={'Upload Inquiries'}
        zIndex={20}
        visible={isVisible}
        style={{ minWidth: MIN_WIDTH }}
        onCancel={() => {
          this.handleModalClose(false);
        }}
        destroyOnClose
        maskClosable={false}
        width={(window as any).screen.width - 100}
        confirmLoading={isUploading || tempUploadFlag}
        footer={
          <div className={classes.footerDiv}>
            <Row className={classes.inquiryAccessDiv}>
              <Col span={4} style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.textSecondary }}>
                Inquiry Access:
              </Col>
              <Col span={20} className={classes.accessField}>
                <Select
                  placeholder="Select Access"
                  onChange={(val) => this.handleAccessTypeChange(val)}
                  defaultValue={teamId ? teamLabel : accessType}
                  value={teamId ? teamLabel : accessType}
                  data-testid={'inquiry-access-select'}
                >
                  {isDefaultInquiryTeamMapping && userData.role !== 'ADMIN' ? (
                        // For now userData.role === 'ADMIN' to test, but change it
                        // to userData.role !== 'ADMIN' before pushing
                        teamMappedAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !teams.length)
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabelsForTeamMapped[item]}
                            </Select.Option>
                          )
                        })
                      ): (
                        defaultAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !teams.length)
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabel[item]}
                            </Select.Option>
                          );
                        })
                      )}
                </Select>
              </Col>
            </Row>
            <div style={{ marginRight: '6%' }}>
              <Button onClick={() => this.handleModalClose(false)}>Cancel</Button>
              <Button type="primary" onClick={this.sendData} loading={this.state.isUploading} data-testid={'upload-inquiry'}>
                Upload
              </Button>
            </div>
          </div>
        }
      >
        <Row style={{ marginLeft: '35px' }}>
          <Col span={3}>
            <span style={{ fontWeight: 'bold' }}>Mode</span>
          </Col>
          <Col span={12}>
            <Radio.Group
              style={{ marginBottom: '15px', marginLeft: '0px' }}
              onChange={this.handleRadioChange}
              value={inquiryMode}
            >
              {inquiryModes
                .map((item) => {
                  return (
                    <Radio value={item.value} data-testid={`radio-${item.value}`}>
                      {item.label}
                    </Radio>
                  );
                })}
            </Radio.Group>
          </Col>
        </Row>
        <Row style={{ marginLeft: '35px' }}>
          <Col span={3}>
            <span style={{ fontWeight: 'bold' }}>My Vendors / Groups</span>
          </Col>
          <Col span={12}>{this.renderSelectFFs(FFType.MY_FF)}</Col>
        </Row>
        {showDiscoverBuyRates && !hideStrategicVendors &&
          (fetchingFFs && !isValidArray(strategicFFs) ? (
            <Spin style={{ margin: '10px 0 0 35px' }} />
          ) : (
            isValidArray(strategicFFs) && (
              <Row style={{ margin: '10px 0 0 35px' }}>
                <Col span={3}>
                  <span style={{ fontWeight: 'bold' }}>Shipsy Vendors</span>
                </Col>
                <Col span={12}>{this.renderSelectFFs(FFType.STRATEGIC_FF)}</Col>
              </Row>
            )
          ))}
        <ExcelUpload
          mapping={this.keyMapping()}
          headerText={'Upload excel file to upload inquiries'}
          sampleLinkInfoText={'Download sample file for inquiries'}
          sampleLinkDownload={this.handleDownloadSampleData}
          onDataParsed={this.handleParsedData}
          fileType={'excel'}
          tempUploadStart={() => this.setState({ tempUploadFlag: true })}
          tempUploadEnd={() => this.setState({ tempUploadFlag: false })}
          fileName="Inquiry_data"
          mapping2={this.keyMapping(true)}
          fileName2={(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL)
            ? "Route_data" 
            : inquiryMode === InquiryModes.FCL 
              ? "Inquiry_Products" 
              : "Packaging_Details"
          }
        ></ExcelUpload>
        {isErrorModalVisible && (
          <FailureArrayHandlerInquiry
            failureData={failureData}
            isVisible={isErrorModalVisible}
            okText={'Retry Errors'}
            successMessage="Inquiry(s) successfully created and sent"
            onModalClose={() => {
              this.setState({
                isErrorModalVisible: false,
              });
            }}
          ></FailureArrayHandlerInquiry>
        )}
        {isSelectTeamModalVisible && (
          <TeamForInquiryAccessModal
            isVisible={isSelectTeamModalVisible}
            teams={teams}
            onCancel={() => {
              this.setState({ teamId, isSelectTeamModalVisible: false });
            }}
            handleTeamSelect={this.handleTeamSelect}
            teamId={teamId}
          />
        )}
      </Modal>
    );
  }
}

const mapStateToProps = ({ inquiryReducer, masterData }) => {
  return {
    masterData: inquiryReducer.masterData,
    showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
    hideStrategicVendors: masterData.modules.hide_strategic_vendors,
    visibleAccessTypes: masterData?.visibleAccessTypes?.INQUIRY ?? [],
    permissions: masterData.permissions,
    userData: masterData.userData,
    isDefaultInquiryTeamMapping: masterData.modules?.enable_default_inquiry_team_mapping,
  };
};

const Styled = injectSheet(styles)(BulkInquiryUpload);
export default withRouter(connect(mapStateToProps, null)(Styled));
